import * as React from 'react'
import { Input, FormGroup, Label } from 'reactstrap'
import * as Modals from 'shared/modals'
import './styles.css'

interface Props extends Modals.ModalComponentProps {
  topic: string
  createOrUpdate: (payload: any) => Promise<any>
}

interface State extends Modals.ModalComponentState {
  topic: string
  error: string
}

const emptyState: State = {
  topic: '',
  error: '',
}

export class AddCommunityTopicModal extends Modals.GenericModalComponent<Props, State> {
  public static key: string = 'AddCommunityTopicModal'

  public static defaultProps = {
    closeButtonText: 'Cancel',
    saveText: 'Save Exclusion',
    secondAction: Modals.ModalActionType.BUTTON,
  }

  constructor(props: Props) {
    super(props, AddCommunityTopicModal.key)
    this.state = emptyState
  }

  public componentDidMount() {
    this.loadFormData()
  }

  public componentDidUpdate(prevProps: Props) {
    // If props changed (modal opened with new data), reload form
    if (prevProps.topic !== this.props.topic) {
      this.loadFormData()
    }
  }

  private loadFormData = () => {
    // If editing existing topic, populate form
    if (this.props.topic) {
      this.setState({
        topic: this.props.topic,
      })
    } else {
      // Reset to empty state for new topic
      this.setState(emptyState)
    }
  }

  protected getTitleText(data: any): string {
    return this.props.topic ? 'Edit Topic Exclusion' : 'Add New Topic Exclusion'
  }

  protected xButtonClick(data: any) {
    this.clearState()
    super.xButtonClick(data)
  }

  protected close(data: any) {
    this.clearState()
    super.close(data)
  }

  protected save(data: any) {
    if (!this.state.topic.trim()) {
      this.setState({ error: 'Please enter a topic name.' })
      return
    }

    const payload = {
      topic: this.state.topic.trim(),
    }

    this.props.createOrUpdate(payload)
      .then(() => {
        this.clearState()
        super.close(data)
      })
      .catch((error) => {
        this.setState({ error: 'Failed to save exclusion. Please try again.' })
      })
  }

  protected saveDisabled(data: any): boolean {
    return !this.state.topic.trim()
  }

  private clearState = () => {
    this.setState(emptyState)
  }

  private setTopic = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ topic: event.target.value, error: '' })
  }



  protected renderChildren(data: any) {
    return (
      <div className="community-topic-modal">
        <div className="community-topic-form">
          {this.state.error && (
            <div className="alert alert-danger" role="alert">
              {this.state.error}
            </div>
          )}

          <FormGroup>
            <Label className="community-topic-label">Topic Name</Label>
            <Input
              type="text"
              value={this.state.topic}
              onChange={this.setTopic}
              placeholder="Enter topic name"
              className="community-topic-input"
              maxLength={255}
            />
          </FormGroup>

        </div>
      </div>
    )
  }
}